import { getTargetedProduct } from '../utils/utils';
import { handleUtagEvent } from '@core/js/actions/initialActions';

/**
 * Fetches targeted product and fires utag analytics event for any product view model
 * @param  {Object} store        Redux store
 * @param  {Object} tab          Accordion tab that triggered the function
 */
export function fireProductDetailsUtagEvent(store, tab) {
    if (tab) {
        const state = store.getState();
        const product = getTargetedProduct(state);
        const productIsMto = product.configurationEnabled;

        const tabSet = tab.closest('.js-accordion-tabset');
        const tabName = tabSet.attr('data-accordion-tab-name');
        const tabAction = tabSet.hasClass('is-collapsed') ? 'collapse' : 'expand';
        let utagLinkData = {};

        if (productIsMto) {
            utagLinkData = {
                "event_category": 'PAGE_TYPE',
                "event_action": `mto - ${_.get(state, 'mto.selectedTabName')}`,
                "event_label": `product ${tabName} ${tabAction}`
            };
        } else {
            utagLinkData = {
                "event_category": 'PAGE_TYPE',
                "event_action": `product ${tabName} ${tabAction}`,
                "event_label": _.get(product, 'product.displayName', '')
            };
        }

        store.dispatch(handleUtagEvent(utagLinkData, 'link'));
    }
}
